import { Order } from '../../services/exports/Interfaces';
import RatingStars from '../review/RatingStars';
import React, { useMemo, useState } from 'react';
import { SCREENS } from '../../services/exports/Constants';
import OrderRatesManager from '../../services/api/OrderRatesManager';
import useNavigate from '../../hooks/navigation/useNavigate';
import { useTranslation } from 'react-i18next';
import useGoogleReview from '../../hooks/google-review/useGoogleReview';
import useAuth from '../../hooks/global/useAuth';
import { useSelector } from 'react-redux';
import { StoreInterface } from '../../store/types';
import classnames from 'classnames';

interface Props {
  order: Order;
  classes?: { container?: string; wrapper?: string };
}

export default function OrderRating({ order, classes }: Props) {
  const { t } = useTranslation(null, { keyPrefix: 'Components:Order:OrderRating' });

  const { company } = useSelector((state: StoreInterface) => state.initialData);

  const { isLoggedIn } = useAuth();
  const { navigate } = useNavigate();
  const { loading, hasGooglePromotion, hasUploadedGoogleReview } = useGoogleReview({ autoLoad: true });

  const [rating, setRating] = useState(order.rates[0]?.rate);

  const showRating = useMemo(
    () => isLoggedIn && hasGooglePromotion && !hasUploadedGoogleReview,
    [isLoggedIn, hasGooglePromotion, hasUploadedGoogleReview],
  );

  function onSelect(rate: number): void {
    if (rate >= 4) {
      setTimeout(
        () =>
          navigate(SCREENS.UPLOAD_GOOGLE_REVIEW_SCREEN, {
            state: {
              prevPage: location?.pathname,
              rating: rate,
              googleReviewHeaderTitle: t('upload_google_review.title'),
            },
          }),
        500,
      );
    }

    OrderRatesManager.create(order.id, { rate });
  }

  return (
    showRating &&
    !loading && (
      <div className={classes?.container}>
        <h6 className="text-sm">{t('title', { name: company?.name })}</h6>
        <p className="mt-xs text-gray-700 text-xs">{t('description')}</p>
        <div
          className={classnames(
            'mt-sm w-fit flex justify-center bg-green p-md rounded-[16px] shadow-section',
            classes?.wrapper,
          )}
        >
          <RatingStars rating={rating} setRating={setRating} onSelect={onSelect} />
        </div>
      </div>
    )
  );
}
